/* eslint-disable no-useless-computed-key */
import React from 'react';
import {
  Card,
  Typography,
  Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import backgroundImage from './images/Request-Appointment-bg.jpg';


const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    zIndex: '0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    maxWidth: '1170px',
    margin: '0 auto',
    ['@media (max-width: 980px)']: {
      flexDirection: 'column',
      maxWidth: '568px',
      padding: '0'
    }
  },
  imageContainer: {
    position: 'absolute',
    left: '0',
    right: '50%',
    top: '0',
    bottom: '0',
    zIndex: '-1',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    ['@media (max-width: 980px)']: {
      position: 'static',
      width: '100%',
      height: '430px'
    }
  },
  formBgMask: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '50%',
    ['@media (max-width: 980px)']: {
      width: '100%'
    }
  },
  formContainer: {
    minHeight: '490px',
    width: '100%',
    maxWidth: '353px',
    margin: '70px 70px 40px auto',
    padding: '0 30px',
    boxSizing: 'content-box',
    ['@media (max-width: 980px)']: {
      margin: '40px auto',
      boxSizing: 'border-box',
    }
  },
  formHeading: {
    color: '#fff',
    fontWeight: '600',
    textTransform: 'uppercase',
    lineHeight: '1.2',
    fontSize: '28px',
    marginBottom: '10px'
  },
  formLegend: {
    color: '#fff',
    fontSize: '13px',
    paddingBottom: '35px'
  },
  fakeField: {
    color: '#fff',
    borderBottom: '1px solid #fff',
    fontSize: '18px',
    marginBottom: '29px',
    padding: '4px 9px'
  },
  fakeTextField: {
    color: '#fff',
    borderBottom: '1px solid #fff',
    fontSize: '18px',
    marginBottom: '29px',
    padding: '4px 9px 40px'
  },
  button: {
    border: '1px solid #fff',
    borderRadius: '0',
    textTransform: 'uppercase',
    backgroundColor: '#3f4542',
    color: '#fff',
    marginTop: '20px',
    paddingRight: '50px',
    paddingLeft: '50px',
    '&:hover': {
      backgroundColor: '#3f4542',
      color: '#fff'
    }
  }
}));

const AppointmentFormBlockPreview = ({
  imageSrc
}) => {
  const classes = useStyles();

  return (
    <Card className="mt-5 p-8">
      <Typography variant="h4" className="mb-5">Preview</Typography>
      <div className={classes.container}>
        <div
          className={classes.imageContainer}
          style={{backgroundImage: `url(${imageSrc})`}}
        />
        <div
          className={classes.formBgMask}
          style={{backgroundImage: `url(${backgroundImage})`}}
        >
          <div className={classes.formContainer}>
            <div className="form-container">
              <div className={classes.formHeading}>REQUEST AN APPOINTMENT</div>
              <div className={classes.formLegend}>*required fields</div>
              <div className={classes.fakeField}>
                Full Name*
              </div>
              <div className={classes.fakeField}>
                Phone*
              </div>
              <div className={classes.fakeField}>
                Email*
              </div>
              <div className={classes.fakeTextField}>
                Message*
              </div>
              <div className="actions-toolbar">
                <div className="primary">
                  <Button
                    variant="contained"
                    className={classes.button}
                    title="Send"
                  >
                    Send
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default AppointmentFormBlockPreview;
